<template>
    <div class="flex recommend">
        <div class="flex-3">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="搜索下拉词：">
                    <el-input
                        type="textarea"
                        wrap="off"
                        v-model="form.keyword"
                        :rows="5"
                        :placeholder="`请在这里输入你需要的批量的查询的关键词\n一行一个搜索词，最多支持5个。\n普通用户只能一次查询一个，vip用户支持5个搜索词`"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <span class="fc-theme fs-12">权重值基于淘宝针对淘宝号推荐算法计算得出，查询结果仅供参考</span>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交查询</el-button>
                </el-form-item>
            </el-form>
            <div class="marginT-20 flex flex-wrap">
                <div class="item" v-for="(item, index) in result" :key="index">
                    <div>{{index}}：</div>
                    <div v-if="result[index].length > 0">
                        <div class="key" v-for="(keyword, i) in result[index]" :key="i">{{keyword[0]}}</div>
                    </div>
                    <div v-else class="text-center">暂无推荐词</div>
                </div>
            </div>
        </div>
        <div class="flex-2 right">
            <h3 class="fs-24 marginB-10">搜索下拉推荐词</h3>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-tabs v-model="activeTip">
                        <el-tab-pane label="搜索下拉推荐词" name="first"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="fs-14" v-if="activeTip == 'first'">
                    <div class="title fc-theme fs-16">搜索下拉推荐词</div>
                    <div class="content fs-12 fc-666">
                        1、通过实时查询官方推荐的关联词，来选择需要做的搜索词
                        <br>2、选择合适的搜索词能快速引流的效果。
                    </div>
                    <div class="title fc-theme fs-16">使用场景</div>
                    <div class="content fs-12 fc-666">
                        1、找到参与做单合适的搜索词，热词排名靠后不易搜索到，可以选择最近淘宝推荐的搜索词来实现快速找到商品同时选择的词的流量较高的
                        <br>2、淘宝搜索下拉框选词是通过淘宝、天猫、手机淘宝搜索下拉框查询淘宝搜索指数高、流量高、转化率高的关键词，并获取各关键词对应的在线相关宝贝数量及其推荐属性词。
                    </div>
                    <div class="title fc-theme fs-16">消费说明</div>
                    <div class="content fs-12 fc-666">
                        1、一个搜索词查询一次非会员{{price.point}}点券/个，会员原价2点券/个，限时优惠{{price.vip_point}}点券/个，会员每月可以额外免费查询{{price.vip_month_given_num}}次，点击<span class="fc-blue point" @click="$router.push('/vip')">开通会员</span>。
                        <br>2、搜索词扣一次费用。查询成功才会扣取点券，查询失败不扣取点券。
                    </div>
                    <div class="content fc-theme">API接口微信号 {{getkfWx()}}</div>
                </div>
                <!-- <div class="fs-14" v-if="activeTip == 'second'">
                    <div class="title fc-theme fs-16">商家的问题：</div>
                    <div class="content fs-12 fc-666">核心词下的商品权重低，商家希望买家同过核心词搜索下单，进而提高商品在核心词的权重。</div>
                    <div class="title fc-theme fs-16">解决方案：</div>
                    <div class="content fs-12 fc-666">商家使用v兔的旺旺强行打标，将商品的排名在指定搜索词提高到前10，买家再搜索后下单购买（打标过商品会在指定的淘宝号下搜索排名在前10），生意参谋数据显示是核心词搜索下单的。能快速的提高商品在核心词的权重值。</div>
                </div>
                <div class="fs-14" v-if="activeTip == 'third'">
                    <div class="title fc-theme fs-16">商家的问题：</div>
                    <div class="content fs-12 fc-666">商家希望买家的淘宝号有自己商品的标签，有标签后下单购买权重提升更高。如何将买家淘宝号的标签打上指定的商品标签呢？</div>
                    <div class="title fc-theme fs-16">解决方案：</div>
                    <div class="content fs-12 fc-666">商家使用v兔的旺旺强行打标，将商品标签第一次打标到用户淘宝号上，用户通过打标词进行浏览商品（为了能快速打上商品的标签，同时做货比三家，同店浏览，咨询客服）完成一次操作，选择店铺里同类商品这样操作进行3到4次，该买家有90%会出现该商品的标签</div>
                </div>
                <div class="fs-14" v-if="activeTip == 'fourth'">
                    <div class="title fc-theme fs-16">商家的问题：</div>
                    <div class="content fs-12 fc-666">商家希望买家能通过手淘首页的猜你喜欢找到商品下单。</div>
                    <div class="title fc-theme fs-16">解决方案：</div>
                    <div class="content fs-12 fc-666">第一步：结合打标攻略2将商品的标签出现在淘宝标签里，搜索找到目标商品，进行浏览，收藏关注，和客服咨询商品的常规信息。
                    <br>第二步：寻找同类的其他商品大概浏览三到四个，随便收藏几个竞品，后期可以取消收藏
                    <br>第三步：重复上述第一、二步，一天操作两到三次。重复3天，重复浏览的商品大概率会在猜你喜欢中出现。</div>
                </div> -->
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { jsonp } from 'vue-jsonp'
export default {
    computed: {
        ...mapState(['userData'])
    },
    props: {
        price: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            activeTip: 'first',
            loading: undefined,
            form: {
                keyword: ''
            },
            result: {}
        }
    },
    methods: {
        async onSubmit() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            window.checkDiscountPackage("tao20w")
            const textList = this.form.keyword.replace(/ /g, '').split('\n').filter(x => x)
            if (textList.length > 1) {
                if (this.userData.is_vip) {
                    if (textList.length > 5) {
                        this.$message.error('一次只能查询5个搜索词')
                        return
                    } else {
                        this.loading = this.$loading({
                            lock: true,
                            text: '提交中',
                            spinner: 'el-icon-loading',
                            background: 'rgba(255, 255, 255, 0.5)'
                        })
                        await this.AuthAll(textList)
                        // await Promise.all(
                        //     textList.map(async (item, index) => {
                        //         await this.getData(item)
                        //     })
                        // )
                        // loading.close()
                        this.$store.dispatch('upDateUser')
                    }
                } else {
                    this.$message.error('普通用户一次只能查询一个搜索词')
                    return
                }
            } else {
                this.loading = this.$loading({
                    lock: true,
                    text: '提交中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.5)'
                })
                await this.AuthAll(textList)
                // this.getData(textList[0])
            }
        },
        async AuthAll(allItem) {
            return new Promise(async (resolve, reject) => {
                await this.xh(allItem, 0)
                resolve(true)
            })
        },
        async xh(list, index = 0) {
            await this.AuthTaobaoKeyword(list[index])
            if (list[index + 1]) {
                setTimeout(async () => {
                    await this.xh(list, index + 1)
                }, 1000);
            } else {

                this.loading.close()
                return true
            }
        },
        async AuthTaobaoKeyword(keyword) {
            const result = await jsonp(`https://suggest.taobao.com/sug?code=utf-8&q=${keyword}`)
            const data = await this.getData(keyword)
            if (data.code == 0) {
                this.$set(this.result, keyword, result.result)
            } else {

            }

        },
        async getData(keyword) {
            const data = await this.$fetch('/api/proxy/web/taosuggest', {keyword, type: 'web'}, 'post')

            return data
            // if (data.code == 0) {
            //     this.$set(this.result, keyword, JSON.parse(data.data.replace(/\r\n/g, '')).result)
            // }
        }
    },
}
</script>

<style lang="scss" scoped>
.right {
    margin-left: 30px;
    .title {
        margin-top: 5px;
    }
}
.recommend {
    .item {
        padding: 10px;
        margin: 10px 20px;
        border-radius: 6px;
        background: #f5f5f5;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        .key {
            background: #999;
            color: #fff;
            margin: 4px 0;
            padding: 0 10px;
            height: 18px;
            line-height: 18px;
            border-radius: 9px;
        }
    }
    ::v-deep textarea {
        resize: none;
    }
}
</style>
<style lang="scss">
.recommend {
    .el-card__header {
        padding-bottom: 0;
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .el-tabs__nav-wrap::after {
        height: 0;
    }
}
</style>
sh -c "$(wget -O- https://raw.githubusercontent.com/robbyrussell/oh-my-zsh/master/tools/install.sh)"


作者: Vincent F0ng
链接: https://vincef0ng.cn/post/iterm2-for-mac-tutorial/
来源: Vincent F0ng
著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
